import { motion } from "framer-motion";

const ROWS = [
  { fault: "STALE",     action: "REFRESHED",    color: "#FF7B5B", preview: "Contact · 2019-05-03" },
  { fault: "DUPLICATE", action: "MERGED",       color: "#FFB800", preview: "acme.co · acme.com" },
  { fault: "MISSING",   action: "ENRICHED",     color: "#D946EF", preview: "—  →  title, dept, size" },
  { fault: "INVALID",   action: "REVALIDATED",  color: "#00F0FF", preview: "bounce@old.com ✗" },
];

export default function DataFoundationVisual() {
  return (
    <div className="w-full h-full flex flex-col justify-center text-[11px] font-mono" data-testid="data-foundation-visual">
      <div className="flex items-center justify-between mb-4 pb-3 border-b border-dashed border-white/10">
        <span className="uppercase tracking-[0.3em] text-[#FF7B5B] font-bold text-[10px]">
          // before · 4 faults
        </span>
        <span className="uppercase tracking-[0.3em] text-[#CCFF00] font-bold text-[10px]">
          after · clean ✓
        </span>
      </div>

      <div className="space-y-2.5">
        {ROWS.map((r, i) => (
          <div key={r.fault} className="grid grid-cols-[1fr_24px_1fr] gap-3 items-stretch">
            {/* Bad */}
            <motion.div
              initial={{ opacity: 0, x: -8 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: i * 0.1 }}
              className="border border-dashed p-2.5 relative"
              style={{ borderColor: r.color + "66" }}
            >
              <div className="flex items-center justify-between mb-1">
                <span className="flex items-center gap-1.5 font-bold" style={{ color: r.color }}>
                  <span>✕</span>
                  <span className="tracking-widest">{r.fault}</span>
                </span>
                <span className="text-zinc-600 text-[9px]">rec_{i + 1}</span>
              </div>
              <div className="text-zinc-500 truncate text-[10px]">{r.preview}</div>
              <div className="mt-1.5 h-[2px] bg-white/5 relative overflow-hidden">
                <motion.div
                  initial={{ width: 0 }}
                  whileInView={{ width: `${30 + i * 10}%` }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 + 0.15, duration: 0.4 }}
                  className="h-full"
                  style={{ background: r.color }}
                />
              </div>
            </motion.div>

            {/* Arrow */}
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 + 0.25 }}
              className="flex items-center justify-center"
            >
              <div className="relative w-6 h-[1px] bg-[#CCFF00]/50">
                <motion.div
                  initial={{ left: "-30%" }}
                  whileInView={{ left: "120%" }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 + 0.3, duration: 0.6, ease: "easeOut" }}
                  className="absolute top-1/2 -translate-y-1/2 h-1.5 w-1.5 rounded-full bg-[#CCFF00]"
                  style={{ boxShadow: "0 0 6px #CCFF00" }}
                />
              </div>
            </motion.div>

            {/* Good */}
            <motion.div
              initial={{ opacity: 0, x: 8 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: i * 0.1 + 0.35 }}
              className="border p-2.5 relative"
              style={{ borderColor: "#CCFF0055", background: "rgba(204,255,0,0.04)" }}
            >
              <div className="flex items-center justify-between mb-1">
                <span className="flex items-center gap-1.5 font-bold text-[#CCFF00]">
                  <span>✓</span>
                  <span className="tracking-widest">{r.action}</span>
                </span>
                <span className="text-zinc-600 text-[9px]">ok</span>
              </div>
              <div className="text-white/80 truncate text-[10px]">accepted</div>
              <div className="mt-1.5 h-[2px] bg-white/5">
                <div className="h-full w-full bg-[#CCFF00]" style={{ boxShadow: "0 0 4px #CCFF00" }} />
              </div>
            </motion.div>
          </div>
        ))}
      </div>

      <div className="mt-5 pt-3 border-t border-dashed border-white/10 flex items-center justify-between text-[9px] uppercase tracking-[0.3em]">
        <span className="text-zinc-500">input rows · 4</span>
        <span className="flex items-center gap-2 text-[#CCFF00]">
          <span className="h-1.5 w-1.5 rounded-full bg-[#CCFF00] animate-pulse" />
          100% clean
        </span>
      </div>
    </div>
  );
}
